/* Generated by scripts/build-content.mjs. Do not edit directly. */

export const articles = [
  {
    "slug": "ganapathi-upasana",
    "title": "Ganapathi Upasana",
    "summary": "Ganapatya darsanam.",
    "publishedDate": "2025-09-20",
    "category": "Upāsanā",
    "author": "Sri Devinatha Mission",
    "keywords": [
      "Ganapathi",
      "Ganapati",
      "Ganapatya",
      "Upasana",
      "Spiritual practice"
    ],
    "featured": true,
    "externalUrl": "https://sridevinathamission.substack.com/p/ganapathi-upasana",
    "searchText": "Ganapathi Upasana Ganapatya darsanam. Upāsanā Sri Devinatha Mission Ganapathi Ganapati Ganapatya Upasana Spiritual practice "
  },
  {
    "slug": "shatdarsanas",
    "title": "Shatdarsanas",
    "summary": "Six ways of Upasana.",
    "publishedDate": "2025-09-20",
    "category": "Darśana",
    "author": "Sri Devinatha Mission",
    "keywords": [
      "Shatdarsanas",
      "Six darshanas",
      "Upasana",
      "Indian philosophy"
    ],
    "featured": true,
    "externalUrl": "https://sridevinathamission.substack.com/p/shatdarsanas",
    "searchText": "Shatdarsanas Six ways of Upasana. Darśana Sri Devinatha Mission Shatdarsanas Six darshanas Upasana Indian philosophy "
  },
  {
    "slug": "the-esoteric-path-of-realization-srishti",
    "title": "The Esoteric Path of Realization — Srishti",
    "summary": "The purpose of human life.",
    "publishedDate": "2025-09-20",
    "category": "Śrīvidyā",
    "author": "Sri Devinatha Mission",
    "keywords": [
      "Srishti",
      "Creation",
      "Sri Vidya",
      "Realization",
      "Human life"
    ],
    "featured": true,
    "externalUrl": "https://sridevinathamission.substack.com/p/the-esoteric-path-of-realization-579",
    "searchText": "The Esoteric Path of Realization — Srishti The purpose of human life. Śrīvidyā Sri Devinatha Mission Srishti Creation Sri Vidya Realization Human life "
  }
] as const;

export const events = [
  {
    "slug": "sarada-navaratri-mahotsavam-2025",
    "title": "Śārada Navarātri Mahotsavam 2025",
    "summary": "Navarātri observances at the Chennai and Konai Ashramams, with daily Śrī Devi Yāga and special pūjās and homams.",
    "startDate": "2025-09-20",
    "endDate": "2025-10-02",
    "venue": "Chennai and Konai Ashramams",
    "address": "16 Thiruvengada Sami Street, Kannabiran Colony, Saligramam, Chennai - 600 093; Sivasakthi Ashramam, Kailasa Konai",
    "gallery": [],
    "html": "<p>The Śārada Navarātri Mahotsavam was celebrated at the Chennai and Konai Ashramams from 20 September to 2 October 2025. Śrī Lalitha Sahasranāma Lakshārchana was performed during Navarātri.</p>\n<h2>Chennai programme</h2>\n<ul>\n<li><strong>20 September - 2 October:</strong> Daily Śrī Devi Yāga</li>\n<li><strong>26 September:</strong> Guru Parva Viśeṣa Alaṅkāram</li>\n<li><strong>28 September:</strong> Chandi Navākṣari Homam as part of the Navakoti Japa Yajña</li>\n</ul>\n<h2>Konai programme</h2>\n<ul>\n<li><strong>20 September:</strong> Gho Pūjā and Dwajārohaṇam</li>\n<li><strong>20 September - 2 October:</strong> Daily Śrī Devi Yāga</li>\n<li><strong>26 September:</strong> Guru Parva Viśeṣa Alaṅkāram</li>\n<li><strong>1 October, morning and evening:</strong> Saraswati Pūjā; Guru, Ganapati, Subramanya, Gāyatri and Panchadaśi Homams; and Chandi Homam as part of the Navakoti Japa Yajña</li>\n<li><strong>2 October:</strong> Vijaya Daśami Pūjā and Chandi Homam as part of the Navakoti Japa Yajña, followed by Dwaja Avarohaṇam</li>\n</ul>\n"
  },
  {
    "slug": "krishna-yajur-veda-evening-classes",
    "title": "Krishna Yajur Veda — Evening Veda Classes",
    "summary": "First batch of the Evening Pāṭhaśālā for boys who have undergone upanayanam.",
    "startDate": "2025-12-14",
    "time": "5:00 pm – 7:00 pm",
    "timezone": "Asia/Kolkata",
    "venue": "Ashramam, Saligramam",
    "address": "2B, Plot No. 34, Door No. 16 Thiruvengadasami Street, Kannabiran Colony, Saligramam, Chennai – 600 093",
    "gallery": [],
    "html": "<p>The Evening Pāṭhaśālā enables children to balance academic pursuits with spiritual growth, imbibe the timeless wisdom of the Vedas and remain anchored in dharmic values while continuing with mainstream schooling.</p>\n<ul>\n<li><strong>Course Content:</strong> Krishna Yajur Veda Samhita Moolam</li>\n<li><strong>Eligibility:</strong> Boys aged 7+ years who have undergone upanayanam</li>\n<li><strong>Course Duration:</strong> 8–10 years</li>\n<li><strong>Class Frequency:</strong> 4–5 classes/week</li>\n<li><strong>Timings:</strong> 5:00 pm – 7:00 pm</li>\n</ul>\n"
  },
  {
    "slug": "vasanta-navaratri-mahotsavam-2026",
    "title": "Vasanta Navarātri Mahotsavam 2026",
    "summary": "Vasanta Navarātri observances at the Chennai and Konai Ashramams, including daily Śrī Devi Yāga and Śrī Lalitha Sahasranāma Lakshārchana.",
    "startDate": "2026-03-17",
    "endDate": "2026-03-28",
    "venue": "Chennai and Konai Ashramams",
    "address": "16 Thiruvengada Sami Street, Kannabiran Colony, Saligramam, Chennai - 600 093; Sivasakthi Ashramam, Kailasa Konai",
    "gallery": [],
    "html": "<p>The Vasanta Navarātri Mahotsavam was celebrated at the Chennai and Konai Ashramams. Śrī Lalitha Sahasranāma Lakshārchana was performed during Navarātri.</p>\n<h2>Konai programme</h2>\n<ul>\n<li><strong>17 March:</strong> Chaturdaśi Pūjā</li>\n<li><strong>18 March:</strong> Gho Pūjā and Dwajārohaṇam</li>\n<li><strong>19-27 March:</strong> Daily Śrī Devi Yāga</li>\n<li><strong>28 March:</strong> Dwaja Avarohaṇam</li>\n</ul>\n<h2>Chennai programme</h2>\n<ul>\n<li><strong>17-27 March:</strong> Daily Śrī Devi Yāga</li>\n<li><strong>22 March:</strong> Śrī Devi Yāga and Śrī Guru, Ganapathy, Subramanya, Sudharshana and Panchadaśi Homams</li>\n</ul>\n"
  },
  {
    "slug": "konai-schools-notebook-distribution-2026",
    "title": "Konai Schools Notebook Distribution 2026-27",
    "summary": "The Mission’s distribution of educational kits and learning materials for approximately 1,600 students from 42 schools.",
    "startDate": "2026-06-20",
    "venue": "Schools around Sivasakthi Ashramam, Kailasa Konai",
    "address": "Narayanavaram Mandal, Tirupati District, Andhra Pradesh",
    "gallery": [],
    "html": "<p>The 2026-27 notebook and educational kit distribution was held on Saturday, 20 June 2026.</p>\n<p>The programme provided educational materials to approximately 1,600 students from 42 schools. The distributed kits included notebooks, school bags, pens, pencils, geometry boxes, water bottles and other essential learning materials.</p>\n<ul>\n<li><strong>Foundation students:</strong> 616</li>\n<li><strong>Elementary students:</strong> 934</li>\n<li><strong>Schools:</strong> 42</li>\n</ul>\n<p>The Mission’s school-support work has continued for 23 years.</p>\n"
  },
  {
    "slug": "adi-krittika-festival-2026",
    "title": "Ādi Kṛttikā Festival 2026",
    "summary": "The annual Ādi Kṛttikā festival at Kailasa Konai, with its principal celebrations on 6 and 7 August 2026.",
    "startDate": "2026-08-04",
    "endDate": "2026-08-08",
    "venue": "Sivasakthi Ashramam, Kailasa Konai",
    "address": "Kailasa Konai, Narayanavanam Mandal, Tirupati District, Andhra Pradesh - 517581",
    "mapUrl": "https://maps.app.goo.gl/yrYmJMha4wZNkjzy7",
    "gallery": [],
    "html": "<p>The annual Ādi Kṛttikā festival programme at Kailasa Konai included the following observances.</p>\n<h2>4 August</h2>\n<ul>\n<li><strong>10:00 am:</strong> Gho Pūjā</li>\n<li><strong>12:15 pm:</strong> Dwajārohaṇam</li>\n</ul>\n<h2>5 August</h2>\n<ul>\n<li><strong>6:00 pm:</strong> Aṣṭami Pūjā</li>\n</ul>\n<h2>6 August</h2>\n<ul>\n<li><strong>9:30 am:</strong> Bharani Abhiṣekam</li>\n<li><strong>11:00 am:</strong> 45th year Lakṣārchana to Śrī Bala Vinayaka Bala Subramanya Swami</li>\n<li><strong>From 4:00 pm:</strong> Annadānam for devotees from villages offering Kavadi</li>\n<li><strong>9:00 pm:</strong> Bhajanai</li>\n</ul>\n<h2>7 August</h2>\n<ul>\n<li><strong>8:00 am:</strong> Kavadi Samarpaṇam by Mandalites</li>\n<li><strong>9:00 am:</strong> Kalasa Sthāpanam, Laghu Nyāsa and Ekādaśa Rudra Pārāyaṇam</li>\n<li><strong>10:15 am:</strong> Ādi Kṛttikā special Abhiṣekam</li>\n<li><strong>11:30 am:</strong> Kalasa Udvāsanam and Abhiṣekam</li>\n<li><strong>12:15 pm:</strong> Alaṅkāra Dīpam</li>\n<li><strong>12:45 pm:</strong> Mahādīpārādhana</li>\n<li><strong>1:00 pm:</strong> Prasādam distribution</li>\n<li><strong>7:00 pm:</strong> Procession of Śrī Bala Vinayaka Bala Subramanya Swami</li>\n</ul>\n<h2>8 August</h2>\n<ul>\n<li><strong>11:45 am:</strong> Dwaja Avarohaṇam</li>\n</ul>\n"
  }
] as const;
